import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import i18next, { t } from 'i18next';
import {  Trans } from 'react-i18next';
import IconButton from '@mui/material/IconButton';;
import CloseIcon from '@mui/icons-material/Close'
import classNames from 'classnames'

import theme from '../../ui/theme'


const styles = {
  paper: {
    boxSizing: 'content-box',
    maxWidth: 270,
    padding: '20px 19px 23px 19px',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 44,
    marginRight: 34,
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    }
  },
  langSelect : {
    width: '100%'
  },
  select: {
    width: '100%', 
    paddingTop: '20px', 
    margin: {top: '20px'},
    "& .MuiOutlinedInput-input": {
      color: "green"
    },
    "& .MuiInputLabel-root": {
      color: "green"
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "green"
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "red"
    },
    "&:hover .MuiInputLabel-root": {
      color: "red"
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "red"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "purple"
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "purple"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple"
    }
  }
}


const mapStateToProps = state => ({
  title: state.application.title,
});

const mapDispatchToProps = dispatch => ({

});

/**
 * Choose Language
 */
class ChooseLanguage extends PureComponent {
  static propTypes = {

  }

  static defaultProps = {
    open: false,
  }

  state = {
    language: i18next.language
  }

  handleLanguageChange = (event) => {
    i18next.changeLanguage(event.target.value)
      .then((res, err) => {
        // this.setState({ ...this.state, language: event.target.value })
        this.props.close()
      })
      // console.log(this.state.language)
  }

  render() {
    // console.log("I got rendered")
    // console.log(this.props)
    const { classes } = this.props
    return (
      <div>
      {/* <Paper className={styles.paper} square> */}
      <Dialog
        open={this.props.open}
        onClose={this.props.close}
      >
      
        <DialogActions style={{ margin: '0px'}}>
          <DialogTitle ><Trans i18nKey='ChooseLanguage.button_choose_language'></Trans></DialogTitle>
          <IconButton onClick={this.props.close}>
            <CloseIcon style={{  color: theme.palette.primary.main}}/>
          </IconButton>
        </DialogActions>
        
        <DialogContent style={{padding: {top: '20px'}}} >

          <Select
            //style={{width: '100%', paddingTop: '20px', margin: {top: '20px'},}}
            style={styles.select}
            sx={{'border-color': 'pink'}}
            label={t('ChooseLanguage.button_choose_language')}
            variant={'standard'}
            defaultValue={this.state.language}
            onChange={(event) => {
              this.handleLanguageChange(event)
             }
            }
          >
            <MenuItem value='en'>English</MenuItem>
            <MenuItem value='de'>Deutsch</MenuItem>
          </Select>


        </DialogContent>
        
      </Dialog>

      </div>
    );
  }
}

export default ChooseLanguage
